import util from '@/libs/util'

const post = util.ajax.post

export const messagenotify = {}

messagenotify.listAll = function (params) {
  return post('/msg/listMsgPushClassify', params)
}
messagenotify.updateReaded = function (params) {
  return post('/msg/readPushMsg', params)
}
messagenotify.listScrolling = function (params) {
  return post('/msg/scrollingNews', params)
}



// WEBPACK FOOTER //
// ./src/api/gip/message/messagenotify.js